import React, { useState } from 'react';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { ViewTab } from './constants';
import ItemTabs from './ItemTabs';
import ItemView from './ItemView';

import './style.scss';

const getActiveTab = (gigsView, sellersView) => {
    const gigsTotal = gigsView.total;
    const sellersTotal = sellersView.total;

    if (sellersTotal > 0 && gigsTotal === 0) {
        return ViewTab.SELLERS;
    }

    return ViewTab.GIGS;
};

const Items = ({ gigsView, sellersView }) => {
    const [activeTab, setActiveTab] = useState(getActiveTab(gigsView, sellersView));

    return (
        <section className="items">
            <ItemTabs activeTab={activeTab} onChange={setActiveTab} />
            <div className="separator" />
            <ItemView activeTab={activeTab} />
        </section>
    );
};

Items.propTypes = {
    gigsView: object,
    sellersView: object,
};

const mapStateToProps = ({ gigsView, sellersView }) => ({
    gigsView,
    sellersView,
});

export { Items };
export default connect(mapStateToProps)(Items);
